import axios from 'axios';
import R from 'ramda';

export default {
  loadApartments () {
    return new Promise(resolve => {
      axios.get('https://datahub-v2.arlingtonva.us/api/Location/ApartmentCondoComplex?$top=10000').then((result) => {
        var temp = R.map(m => {
          m.id = m.apartmentCondoComplexKey;
          if (!m.id) {
            console.log(m);
          }
          m.lat = parseFloat(m.latitudeCrd);
          m.lng = parseFloat(m.longitudeCrd);
          return m;
        }, result.data);

        resolve(temp);
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/apartments/apartments.service.js